// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltip_tooltip__TcPT7","tooltip__top":"tooltip_tooltip__top__gWV+A","open":"tooltip_open__o0U+O"};